<template>
    <ValidationObserver ref="validationObserver" slim>
        <div>
            <ErrorLogShower />
            <Progressbar processType="BnT" :currentStepIndex="0" />

            <div class="contentblock">
                <section class="contentblock__content">

                    <MigrosLoginInfo v-if="!CurrentTransaction.isCampaignOffer" containerClass="shop__fieldgroup shop__fieldgroup--no-separator shop__fieldgroup--no-padding-bottom shop__fieldgroup--no-padding-top" />

                    <div class="shop__fieldgroup" v-if="IsPartnerLink">
                        <div class="shop__fieldgroup-title">{{Strings['Shop.Partner.Subtitle']}}</div>
                        <p class="shop__partner-text">{{Strings['Shop.Partner.Intro']}}</p>
                        <p class="shop__partner-text">{{Strings['Shop.Partner.TextHeizoel']}}</p>
                        <p class="shop__partner-text">
                            <strong>{{Strings['Shop.Partner.TelOrderTitle']}}</strong>
                            <br />
                            {{Strings['Shop.Partner.TelOrderText']}}
                        </p>
                    </div>

                    <div class="shop__fieldgroup">
                        <div class="shop__fieldgroup-title">{{NumberOfPositions >= 2 ? Strings['Shop.TitleUnloadingPoints'] : Strings['Shop.TitleUnloadingPoint']}}</div>
                        <UnloadingpointInput :AmountUnits="Strings['Shop.UnitsLiter']" :MaxNumPositions="3" :Presets="[2000,3000,4000,5000]" />
                        <div class="migrol-form__buttons" v-if="DirectPriceActivated || CurrentTransaction.isCampaignOffer" style="margin-top: 3rem">
                            <button class="migrol-form__button migrol-form__button--green" @click.prevent="gotoPrice">
                                <span class="migrol-form__button-label">{{Strings['Shop.ButtonCalculatePrice']}}</span>
                            </button>
                        </div>
                    </div>
                    <div class="shop__fieldgroup">
                        <div class="shop__fieldgroup-title">{{Strings['Shop.Options']}}</div>
                        <DeliveryPeriodPicker mode="BnT" />                        
                        <DiscountCodeInput>
                            <button class="migrol-form__button migrol-form__button--green migrol-form__button--narrow" @click.prevent="gotoPrice">
                                <span class="migrol-form__button-label"><i class="fas fa-caret-right"></i></span>
                            </button>
                        </DiscountCodeInput>

                        <div class="shop__options-block" v-if="CouponPromo">
                            <div class="buy-energy-header__product-details__teaser">
                                <div class="buy-energy-header__product-details__title">
                                    {{CouponPromo.Title}}
                                    <svg viewBox="0 0 56 56"
                                         xmlns="http://www.w3.org/2000/svg" class="buy-energy-header__product-details__title__promo-icon">
                                        <g fill="none" fill-rule="evenodd">
                                            <path fill="currentColor" d="m28 52.7-5.5 2.8-3.9-4.7-6.2.5-1.8-5.9-5.9-1.8.5-6.2-4.7-3.9L3.3 28 .5 22.5l4.7-3.9-.5-6.2 5.9-1.8 1.8-5.9 6.2.5L22.5.5 28 3.3 33.5.5l3.9 4.7 6.2-.5 1.8 5.9 5.9 1.8-.5 6.2 4.7 3.9-2.8 5.5 2.8 5.5-4.7 3.9.5 6.2-5.9 1.8-1.8 5.9-6.2-.5-3.9 4.7z"></path>
                                            <path d="M37 41.4c-1.5 0-2.8-.5-3.9-1.4-1-.9-1.5-2.1-1.5-3.8v-3.7c0-1.7.5-3 1.5-3.8 1-1 2.4-1.4 4-1.4 1.5 0 2.9.4 3.9 1.3 1 1 1.5 2.2 1.5 3.9v3.7c0 1.6-.5 3-1.5 3.8-1 1-2.4 1.4-4 1.4ZM24 41h-3.8l12.7-26.9h3.9L24 41.2Zm-4.1-13c-1.6 0-3-.4-4-1.3-1-1-1.5-2.2-1.5-3.9v-3.7c0-1.6.5-2.9 1.6-3.8 1-1 2.3-1.4 3.9-1.4s2.9.5 4 1.4c1 .8 1.5 2.1 1.5 3.8v3.7c0 1.7-.6 3-1.6 3.8-1 1-2.3 1.4-4 1.4Zm19 4.5c0-1.4-.6-2.1-1.8-2.1-1.3 0-2 .7-2 2.1V36c0 1.5.7 2.2 2 2.2 1.2 0 1.9-.7 1.9-2.2v-3.4ZM22 19.3c0-1.4-.7-2.1-2-2.1s-2 .7-2 2.1v3.5c0 1.4.7 2.1 2 2.1s2-.7 2-2.1v-3.5Z" fill="#A4091E" fill-rule="nonzero"></path>
                                        </g>
                                    </svg>
                                </div>
                                <div class="buy-energy-header__product-details__teaser__content migrol-rt-content" v-html="CouponPromo.Content"></div>
                            </div>
                        </div>

                    </div>

                    <div class="shop__fieldgroup shop__fieldgroup--no-separator shop__fieldgroup--no-padding-bottom shop__zipcode-blocked" v-if="isZipCodeBlocked">
                        <div class="shop__error-message-block">{{Strings['Shop.ZipCodeUnavailable']}}</div>
                    </div>

                    <ValidationProvider :name="Strings['Shop.Product']" rules="required" v-slot="{ errors }" slim v-if="!isZipCodeBlocked">
                        <div class="shop__fieldgroup" :class="{'has-error': errors.length > 0}">
                            <HeizoelMaterialPicker v-model="SelectedMaterial" :showPrice="PricesAvailable" />
                            <div class="shop__error-message" v-show="errors.length > 0">{{errors[0]}}</div>
                        </div>
                    </ValidationProvider>

                    <div class="shop__fieldgroup shop__fieldgroup--no-separator">
                        <MyClimateInput />
                    </div>

                    <div class="migrol-form__buttons" v-if="!isZipCodeBlocked">
                        <AjaxButton :isWaitingForAjax="isWaitingForAjax" :label="Strings['Shop.ButtonCreateEmailOffer']" v-if="ShowOfferButton" v-show="!isWaitingForAjax" @buttonClick="offerClick" />
                        <AjaxButton :isWaitingForAjax="isWaitingForAjax" :label="Strings['Shop.ButtonCreateDirectOrder']" v-if="ShowOrderButton" cssclass="migrol-form__button--green" @buttonClick="orderClick" />
                    </div>

                </section>
            </div>
        </div>
    </ValidationObserver>

</template>

<script>
    import UnloadingpointInput from '../_common/UnloadingpointInput'
    import DeliveryPeriodPicker from '../_common/DeliveryPeriodPicker'
    import MyClimateInput from '../_common/MyClimateInput'
    import DiscountCodeInput from '../_common/DiscountCodeInput'
    import Progressbar from '../_common/Progressbar'
    import HeizoelMaterialPicker from './HeizoelMaterialPicker'
    import ErrorLogShower from '../_common/ErrorLogShower'

    import { stepBeforeRouteLeave, triggerValidation } from '@/utils/utils'

    import { ValidationObserver, ValidationProvider } from 'VeeValidate'

    import Transaction from '@/models/Transaction'
    import Price from '@/models/Price'
    import { PriceRequestOutcomes } from '@/utils/constants';


    import { mapState, mapActions, mapGetters } from 'vuex'

    export default {
        computed: {
            ...mapState([
                'Strings',
                'DirectPriceActivated',
                'Product',
                'IsPartnerLink',
                'HideOfferButtonIfPriceAvailable',
                'PriceCalculationOutcome',
                'CouponPromo'
            ]),
            ...mapGetters([
                'isWaitingForAjax',
                'isZipCodeBlocked'
            ]),
            CurrentTransaction() {
                return Transaction.query().with(['material', 'positions.warenempfaenger', 'deliveryPeriod']).first();
            },
            CanCalculatePrice() {
                return this.CurrentTransaction.arePriceRelevantPropertiesSet(this.Product);
            },
            PriceRelevantPropertiesWatcher() {
                return this.CurrentTransaction.priceRelevantPropertiesWatcher();
            },
            PricesAvailable() {
                return Price.query().count() > 0;
            },
            IsCouponInvalid() {
                return this.PriceCalculationOutcome != null && this.PriceCalculationOutcome == PriceRequestOutcomes.CouponInvalid;
            },
            ShowOrderButton() {
                return (this.DirectPriceActivated && this.PricesAvailable) || this.CurrentTransaction.isCampaignOffer;
            },
            ShowOfferButton() {
                return !this.CurrentTransaction.isCampaignOffer //no offers for campaigns
                    && !(this.PricesAvailable && this.HideOfferButtonIfPriceAvailable) //check HideOfferButtonIfPriceAvailable configurable option
                    && !this.IsCouponInvalid; //hide when there is an invalid coupon
            },
            NumberOfPositions() {
                return this.CurrentTransaction.positions.length;
            },
            SelectedMaterial: {
                get() {
                    return this.CurrentTransaction.material;
                },
                set(material) {
                    Transaction.update({
                        id: this.CurrentTransaction.id,
                        material_id: material == null ? null : material.id
                    });
                }
            },
            AllowedNavigationPaths() {
                let paths = [];

                if (this.ShowOfferButton) {
                    //forward to offer-addresses
                    paths.push({ path: '/offer-addresses', requiresValidation: true });
                }

                if (this.ShowOrderButton) {
                    //forward to order-addresses
                    paths.push({ path: '/order-addresses', requiresValidation: true });
                }

                return paths;
            }
        },
        watch: {
            PriceRelevantPropertiesWatcher: {
                handler: function () {
                    if (this.CanCalculatePrice) {
                        this.CalculatePrices();
                    }
                }
            },
            CanCalculatePrice(newValue) {
                if (newValue === false)
                    this.ClearPrices();
            }
        },
        methods: {
            ...mapActions([
                'CalculatePrices',
                'ClearPrices'
            ]),
            offerClick() {
                //validation will automatically be done when trying to leave route
                this.$router.push('/offer-addresses').catch(() => { });
            },
            orderClick() {
                //for campaigns we always show the order button, so we have to validate first, before we check for a price...
                if (this.CurrentTransaction.isCampaignOffer) {
                    triggerValidation(this.$refs.validationObserver).then((isValid) => {
                        if (!isValid) {
                            return;
                        }

                        //make sure, we have a price
                        if (!this.PricesAvailable) {
                            //if for some reason we have no prices for a campaign, the user is stuck here...
                            return;
                        }

                        //validation will automatically be done when trying to leave route
                        this.$router.push('/order-addresses').catch((xxx) => { console.log(xxx); });

                    });
                } else {

                    //validation will automatically be done when trying to leave route
                    this.$router.push('/order-addresses').catch((xxx) => { console.log(xxx); });
                }
            },
            gotoPrice() {
                //validate before we scroll
                triggerValidation(this.$refs.validationObserver).then((isValid) => {
                    if (!isValid) {
                        return;
                    }

                    //scroll to the prices / zipcode block message:
                    if (this.isZipCodeBlocked) {
                        //scroll to the zipcode block:
                        let element = document.getElementsByClassName('shop__zipcode-blocked')[0];
                        element.scrollIntoView({ behavior: "smooth", block: "center" });
                    } else {
                        //scroll to the prices:
                        let element = document.getElementsByClassName('shop__materials')[0];
                        element.scrollIntoView({ behavior: "smooth", block: "center" });
                    }
                });
            }
        },
        mounted() {
            var vm = this;
            if (vm.CanCalculatePrice && !vm.PricesAvailable) {
                window.setTimeout(() => {
                    vm.CalculatePrices();
                    //WWW-2008: jump to price once we have it
                    vm.gotoPrice();
                }, 800);
            }
        },
        beforeRouteLeave(to, from, next) {
            stepBeforeRouteLeave(this.AllowedNavigationPaths, this.$refs.validationObserver, to, next);
        },
        components: {
            UnloadingpointInput,
            DeliveryPeriodPicker,
            MyClimateInput,
            DiscountCodeInput,
            HeizoelMaterialPicker,
            ValidationObserver,
            ValidationProvider,
            Progressbar,
            ErrorLogShower
        }
    };
</script>